import {
  delay,
  call,
  select,
  takeEvery,
  takeLatest,
  put,
  all,
  fork,
} from 'redux-saga/effects';
import * as sagaCommon from '../sagasCommon';
import * as api from '../../services/shipping_method/api_shipping_method';
import * as apiCommon from '../../services/apiCommon';
import * as docTypes from '../../constants/constant_doc_types';
import * as sagaTypes from '../../constants/constant_saga_types';

export default function* (app) {
  try {
    yield all([
      fork(fetchListShippingMethodSaga, app),
      fork(saveShippingMethodSaga, app),
      fork(deleteShippingMethodSaga, app),
      fork(fetchShippingMethodByIdSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_shipping_method: ', e.message || e.stack);
    throw e;
  }
}

function* callFetchListShippingMethod(app, action) {
  try {
    const { silent, filters } = action;
    yield sagaCommon.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: docTypes.SHIPPING_METHOD,
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(sagaCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (e) {
    yield sagaCommon.showErrorListTable(e);
  }
}

function* fetchListShippingMethodSaga(app) {
  yield takeLatest('FETCH_LIST_SHIPPING_METHOD', callFetchListShippingMethod, app);
}

function* callSaveShippingMethod(app, action) {
  try {
    yield sagaCommon.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const params = { tenant, user, data: action.data };
    const result = yield call(api.saveDoc, app, params);
    yield sagaCommon.doneSaveRecord(result, 'Shipping method was saved');
    yield put({
      type: sagaTypes.SIMPLE_FORM_SET_DATA,
      data: result,
    });
    yield callFetchListShippingMethod(app, { silent: true });
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

function* saveShippingMethodSaga(app) {
  yield takeLatest('SAVE_SHIPPING_METHOD', callSaveShippingMethod, app);
}

export function* callDeleteShippingMethod(app, action) {
  try {
    yield sagaCommon.showProgressDeleteRecord();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    yield call(api.deleteDoc, app, params);
    yield sagaCommon.doneDeleteRecord(id, docTypes.SHIPPING_METHOD);
    yield delay(2000);
    yield callFetchListShippingMethod(app, { silent: true });
  } catch (e) {
    yield sagaCommon.showErrorDeleteRecord(e);
  }
}

function* deleteShippingMethodSaga(app) {
  yield takeLatest('DELETE_SHIPPING_METHOD', callDeleteShippingMethod, app);
}

function* callFetchShippingMethodById(app, action) {
  try {
    yield sagaCommon.showProgressDataById();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    const result = yield call(api.fetchDocById, app, params);
    yield sagaCommon.doneDataById(result);
    yield put({
      type: sagaTypes.SIMPLE_FORM_SET_DATA,
      data: result,
    });
  } catch (e) {}
}

function* fetchShippingMethodByIdSaga(app) {
  yield takeEvery('FETCH_SHIPPING_METHOD', callFetchShippingMethodById, app);
}
